import React from 'react';
import { useTheme } from 'styled-components';

import { getColor } from '../../V2/Elements/Icons/helpers.ts';
import type { IIcon } from './types.ts';

const Icon = React.forwardRef<SVGSVGElement | null, IIcon>(function Icon({ size = 24, alt, color, className, onClick }, ref) {
  const theme = useTheme();
  const fillColor = React.useMemo(() => getColor({ color, alt, theme }), [color, alt, theme]);
  return (
    <svg
      ref={ref}
      onClick={onClick}
      width={size}
      height={size}
      viewBox='0 0 24 24'
      fill='none'
      className={className}
      data-testid='edit-button-svg'>
      <path d='M12 17H18' stroke={fillColor} strokeWidth='1.6' strokeLinecap='round' strokeLinejoin='round' />
      <path
        d='M14.6734 6.39918C14.929 6.14359 15.2756 6 15.6371 6C15.8161 6 15.9933 6.03525 16.1587 6.10374C16.324 6.17224 16.4743 6.27263 16.6008 6.39918C16.7274 6.52574 16.8278 6.67598 16.8963 6.84134C16.9647 7.00669 17 7.18392 17 7.36289C17 7.54187 16.9647 7.7191 16.8963 7.88445C16.8278 8.0498 16.7274 8.20005 16.6008 8.3266L8.5699 16.3575L6 17L6.64247 14.4301L14.6734 6.39918Z'
        stroke={fillColor}
        strokeWidth='1.6'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
});

export default React.memo(Icon);
